// export enum ORDER_MODES {
//     SIMPLE = "SIMPLE" as any,
//     ADVANCED = "ADVANCED" as any,
// }

export enum VARIANT_FORM_ORDER_MODE {
    ADD = "ADD" as any,
    EDIT = "EDIT" as any,
}

export const VIRTUAL_DELIVERY_WINDOW_INCREMENT = 5;

export const SEARCH_PRODUCTS_MAX_LENGTH = 100;
